import React, { useEffect } from "react";
import { FaMusic } from "react-icons/fa";
import { SiAudioboom } from "react-icons/si";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { Button } from "@mui/material";
import MusicPopUp from "../../components/musicPopUp/MusicPopUp";
import { useMusic } from "../../context/MusicContext";
import { useAudio } from "../../context/AudioContext";

import { ImHeadphones } from "react-icons/im";
import AudioPopUp from "../../components/audioPopUp.jsx/AudioPopUp";
import { MdCheckCircle } from "react-icons/md";

const BottomNavBar = () => {
  const locaiton = useLocation();
  const musicContext = useMusic();
  const audioContext = useAudio();
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 w-full justify-center text-center bg-black py-4 flex h-30">
      {musicContext.song.title ? <MusicPopUp /> : ""}
      {audioContext.audioData.title ? <AudioPopUp /> : ""}

      <NavLink
        to="/"
        className="text-white w-1/2 flex flex-col items-center justify-center"
        style={({ isActive }) => {
          return isActive || locaiton.pathname.includes('audio')  ? { color: "#f4c430" } : {};
        }}
      >
        <ImHeadphones fontSize={25} />
        <span className="text-xs mt-2">Audio Book</span>
      </NavLink>

      <NavLink
        to="/music"
        className="text-white w-1/2 flex flex-col items-center justify-center"
        style={({ isActive }) => {
          return isActive || locaiton.pathname.includes('music') ? { color: "#f4c430" } : {};
        }}
      >
        <FaMusic fontSize={25} />
        <span className="text-xs mt-2 ">Music</span>
      </NavLink>

      <NavLink
      to="account/my-account"
      className="text-white w-1/2 flex flex-col items-center justify-center"
      style={({ isActive }) =>
        isActive || locaiton.pathname.includes('account')
          ? { color: "#f4c430" }
          : {}
      }
    >
      <MdCheckCircle fontSize={25}/>
      <span className="text-xs mt-2">Subscribe</span>
    </NavLink>

      
    </div>
  );
};

export default BottomNavBar;
